import { IconDashed, IconGhost, IconPage, IconStack } from '@lib/icons'

import { NODE_FRAME, NODE_GHOST, NODE_STACK } from '@/constants/constants'

export const getFrameViewIcon = (variant: string, width?: number) => {
  switch (variant) {
    case NODE_FRAME:
      return <IconDashed width={width} />
    case NODE_GHOST:
      return <IconGhost width={width} />
    case NODE_STACK:
      return <IconStack width={width} />
    default:
      return <IconPage width={width} />
  }
}
